import {StyledMessage} from './style'
import {ReactNode} from 'react'

export const MessageCard = ({
    children,
    fullWidth,
    className
}: {
    children: ReactNode
    fullWidth?: boolean
    className?: string
}) => {
    return (
        <StyledMessage direction="column" gap={2} fullWidth={fullWidth} className={className}>
            {children}
        </StyledMessage>
    )
}
